<template>
  <div class="selector">
    <div class="selector-headers">
      <li :class="{
        'selector-selected-item':selected.header===item
      }" v-for="(item, index) in headers" :key="index" class="selector-header-item" @click="onHeaderClick(item)">
        {{item}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="selector-items">
      <li v-for="(item, index) in items" :key="index" class="selector-item" @click="onSelected(item)">
        {{item.text}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="selector-items">
      <li v-for="(item, index) in all" :key="index" class="selector-item" @click="onSelected(item)">
        {{item.text}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="select-form">
      <div  class="form-horizontal">
        <color-form :color="color"></color-form>
        <div class="form-group">
          <div class="col-sm-10 col-sm-offset-2">
            <button class="btn btn-default" @click="addColor">添加</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as TYPES from '../../store/types'
import ColorForm from '@/components/forms/Color'
export default {
  components: {
    ColorForm
  },
  data() {
    return {
      color: {},
      selected: {
        header: '',
        item: {}
      }
    }
  },
  computed: {
    headers() {
      return this.$store.state.colors.selector.headers
    },
    items() {
      return this.$store.state.colors.selector.items
    },
    all() {
      return this.$store.state.colors.all
    }
  },
  created() {
    this.$store.dispatch(TYPES.DO_GET_COLORS_SELECTOR_HEADERS)
    this.$store.dispatch(TYPES.DO_GET_ALL_COLORS)
  },
  methods: {
    onHeaderClick(item) {
      this.$store
        .dispatch(TYPES.DO_GET_COLORS_BY_SEARCH_SELECTOR_HEADER, item)
        .then(res => {
          this.selected.header = item
        })
    },
    onSelected(item) {
      this.$emit('onSelected', item)
    },
    addColor() {
      this.$store.dispatch(TYPES.DO_ADD_COLOR, this.color)
      .then(res => {
        this.$notify({
          type: 'success',
          content: '成功添加颜色'
        })
        this.onHeaderClick(this.selected.header)
      })
      .catch(res => {
        console.log(res)
        this.$notify({
          type: 'danger',
          content: res.data.msg
        })
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/selectors/Color.vue